module.exports = __webpack_public_path__ + "images/psp/bicycleSizeGuide/bicycle-10x10.svg";